import { getUserInitials } from "@/utils";
import { getColorForId } from "@/utils/avatars";
import ColorAvatar, { colorBorderClass } from "./color-avatar";
import { Avatar, AvatarFallback, Button, Popover, useOverlayState } from "@heroui/react";
import { User } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import NetworkDetailsDrawer from "../desktop/drawers/network-details-drawer";

const stopBubble = (e) => e.stopPropagation();

const popoverActionClass =
  "justify-start items-center gap-2.5 rounded-xl px-3 lg:h-auto h-10 font-medium lg:text-xs text-sm text-left";

const AvatarWithStatus = ({ member, size = "sm", color, name }) => {
  const isLarge = size === "lg";

  return (
    <div className="relative inline-flex shrink-0">
      <ColorAvatar id={member.member_id || member.id} name={name} color={color} size={size} />
    </div>
  );
};

const MemberAvatar = ({ member, color, fullname, size = 'sm' }) => {
  const navigate = useNavigate();
  const name = fullname ?? member.fullname;
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const connectionDrawerState = useOverlayState();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const memberId = member?.id ?? member?.member_id;

  const resolvedColor = color ?? getColorForId(memberId);

  const handleViewConnection = () => {
    setIsPopoverOpen(false);
    if (isMobile) {
      navigate(`/network/${memberId}`);
    } else {
      connectionDrawerState.open();
    }
  };

  return (
    <span onPointerDown={stopBubble} onClick={stopBubble} className="inline-flex">
      <Popover isOpen={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <Popover.Trigger>
          <ColorAvatar name={member.member_fullname || member.fullname} id={member.member_id || member.id} size= {size}/>
        </Popover.Trigger>

        <Popover.Content className={'rounded-2xl'}>
          <Popover.Dialog className="flex flex-col lg:gap-1 gap-3 min-w-[220px] p-1">
            <div className="flex items-center gap-3 px-2 pt-2">
              <ColorAvatar name={member.member_fullname || member.fullname} id={member.member_id || member.id} />

              <div className="flex flex-col">
                <span className="font-bold leading-tight capitalize lg:text-xs">{name}</span>
              </div>
            </div>

            <div className="border-t border-separator" />

            <Button variant="ghost" fullWidth className={popoverActionClass} onPress={handleViewConnection}>
              <User className="size-4" />
              View Connection
            </Button>
          </Popover.Dialog>
        </Popover.Content>
      </Popover>

      <NetworkDetailsDrawer state={connectionDrawerState} _connection_id={member.id} />
    </span>
  );
};

export default MemberAvatar;
